import axios from 'axios';
const { getToken } = require('./token');

const urlParams = {};

export default class AxiosHelper {
  static baseUrl = process.env.REACT_APP_PROD_SERVER_URL + '/api/';

  static getHeaders() {
    const token = getToken();
    return {
      Authorization: `Bearer ${token}`
    };
  }

  static makeAxiosRequest(
    requestType,
    controllerName,
    endpointName,
    urlParams,
    body
  ) {

    const stringifiedParams = {};
    if (urlParams) {
      for (const key in urlParams) {
        stringifiedParams[key] = String(urlParams[key]);
      }
    }

    const url = `${this.baseUrl}${controllerName}/${endpointName}${
      urlParams ? '?' + new URLSearchParams(stringifiedParams) : ''
    }`;
    switch (requestType) {
      case "Create":
        return AxiosHelper.create(url, body);

      case "Read":
        return AxiosHelper.read(url);

      case "Update":
        return AxiosHelper.update(url, body);

      case "Delete":
        return AxiosHelper.delete(url, body);

      default:
        throw new Error('Invalid request type');
    }
  }

  static create(url, body) {
    const requestHeader = AxiosHelper.getHeaders();
    console.log(body)
    return axios.post(url, body, { headers: requestHeader });
  }

  static read(url) {
    const requestHeader = AxiosHelper.getHeaders();
    return axios.get(url, { headers: requestHeader });
  }

  static update(url, body) {
    const requestHeader = AxiosHelper.getHeaders();
    return axios.put(url, body, { headers: requestHeader });
  }

  static delete(url, body) {
    const requestHeader = AxiosHelper.getHeaders();
    return axios.delete(url, { data: body, headers: requestHeader });
  }
}
